export type ViewportBounds = { north: number; south: number; east: number; west: number };

/** Camera rectangles start at the northwest corner and proceed clockwise. */
export function viewportBounds(
  vertices: readonly { lat: number; lon: number }[],
): ViewportBounds | null {
  if (vertices.length !== 5) return null;
  const [nw, ne, se, sw, end] = vertices;
  if (
    !nw ||
    !ne ||
    !se ||
    !sw ||
    !end ||
    nw.lat <= sw.lat ||
    nw.lat !== ne.lat ||
    se.lat !== sw.lat ||
    nw.lon !== sw.lon ||
    ne.lon !== se.lon ||
    nw.lat !== end.lat ||
    nw.lon !== end.lon
  )
    return null;
  return { north: nw.lat, south: sw.lat, west: nw.lon, east: ne.lon };
}
